import { render, staticRenderFns } from "./OnboardLayout.vue?vue&type=template&id=2144857b&"
import script from "./OnboardLayout.vue?vue&type=script&lang=js&"
export * from "./OnboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports